import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import classNames from 'classnames';
import { NeuroMessage, useProduct, useGuideConfig, useNeuroMessages } from "@ignitesales/neuro-application";
import ProductActionButton from './ProductActionButton';
import Collapsible from "react-collapsible";

const Product = ({ ctaHandlers, isDetails, getProductsFromCompanion, isAddOn, isRecommended, product }) => {
    const {
        description,
        descriptionAbbreviated,
        disclosures,
        features,
        isSelected,
        name,
        buttonText,
        onProductActionClick,
        onSelectClick,
        url,
        applyUrl
    } = useProduct(product);
    const { hasMessage } = useNeuroMessages();
    const { isBranchGuide } = useGuideConfig();
    const componentClass = 'product';
    const learnMoreText = 'Learn More';
    const contactMeText = 'Contact Me';
    const relatedCompanions = 'related-companions';

    const hasPhoneLink = hasMessage(`${product.id}.phoneLink`);
    const hasContactMe = hasMessage(`${product.id}.contactMe`);

    const renderProductFeatures = () => {
        return (features.length) ? <div className={`${componentClass}__features`}>
            <Collapsible open={isDetails} trigger={<div classNames="product_features_header"><NeuroMessage id="product.features.title" /></div>}>
                <ol>{features.map((f, i) => <li key={i}>{f}</li>)}</ol>
            </Collapsible>
        </div> : null;
    };

    const renderProductDisclosures = () => {
        return (disclosures.length) ? <div className={`${componentClass}__disclosures`}>
            <Collapsible open={isDetails} trigger={<div classNames="product_disclosures_header"><NeuroMessage id="product.disclosures.title" /></div>}>
                <ol>{disclosures.map((f, i) => <li key={i}><FormattedHTMLMessage id={`${product.id}.disclosures.${i + 1}`} /></li>)}</ol>
            </Collapsible>
        </div> : null;
    };

    const classes = classNames(componentClass, { 'add-on': isAddOn });

    const scrollToView = id => () => {
        const element = document.getElementById(id);
        element.scrollIntoView({
            behavior: 'smooth',
            inline: 'center'
        });
    };

    const onAddToCart = () => {
        if(!isSelected) {
            onSelectClick();
        }
        ctaHandlers.setShowContactForm(true);
    }

    const renderRelatedCompanionActions = () => !isAddOn && product.addOns.some(addOn => isRecommended(addOn.id)) && (<div className={`${componentClass}__companion_actions`}>
        <div className={`${relatedCompanions}__container`}>
            <div className={`${relatedCompanions}__header`}><NeuroMessage id="products.relatedCompanions" /></div>
            <div className={`${relatedCompanions}__links`}>
                {product.addOns.map(addOn => isRecommended(addOn.id)
                    ? <button className={`${relatedCompanions}__link`} onClick={scrollToView(addOn.id)}><a>{addOn.name}</a></button>
                    : '')
                }
            </div>
        </div>
    </div>);

    const renderRelatedProductActions = () => isAddOn && (<div className={`${componentClass}__companion_actions`}>
        <div className={`${relatedCompanions}__container`}>
            <div className={`${relatedCompanions}__header companion`}><NeuroMessage id="products.freeWhenAcquiring" /></div>
            <div className={`${relatedCompanions}__links companion`}>
                {getProductsFromCompanion(product.id).map(p => <button className={`${relatedCompanions}__link`} onClick={scrollToView(p.id)}><a>{p.name}</a></button>)}
            </div>
        </div>
    </div>);

    const renderCTAs = () => <div className={`${componentClass}__actions`}>
        {hasContactMe && <ProductActionButton className="apply-now" action={() => ctaHandlers.setShowContactForm(true)} buttonText={contactMeText} onClick={onAddToCart} />}
        {!hasContactMe && applyUrl && <ProductActionButton className="apply-now" buttonText={buttonText} url={applyUrl} onClick={onProductActionClick} />}
        {hasPhoneLink && <FormattedHTMLMessage className="phone-link" id={`${product.id}.phoneLink`} />}
        {url && <ProductActionButton buttonText={learnMoreText} url={url} />}
    </div>

    return <div className={classes}>
        <div id={product.id} className={`${componentClass}__anchor`} />
        <div className={`${componentClass}__details_container`}>
            <div className={`${componentClass}__title`}>
                <h4>{name}</h4>
            </div>
            <div className={`${componentClass}__details`}>
                <span className={`${componentClass}__description`}>{descriptionAbbreviated}</span>
                <span className={`${componentClass}__description_full`}>{description}</span>
                {renderProductFeatures()}
                {renderProductDisclosures()}
            </div>
        </div>
        {!isDetails && <div className={`${componentClass}__actions_container`}>
            {renderCTAs()}
            {renderRelatedCompanionActions()}
            {renderRelatedProductActions()}
        </div>}
    </div>;
};

Product.defaultProps = {
    isDetails: false,
    getProductsFromCompanion: () => { },
    isAddOn: false,
    isRecommended: () => { },
    product: {}
};

export default Product;
